var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class PlanarMSeries {
    constructor(socket, log) {
        this.socket = socket;
        this.firmwareVersion = '1.2.0';
        this.power = false;
        this.videoSelection = 'HDMI.1';
        this.volume = '50';
        this.volumeMute = false;
        this.asyncHandlers = [
            {
                name: 'firmwareQuery',
                regExp: /BUILD\.INFO\?/i,
                callback: (match) => {
                    this.socket.send(`BUILD.INFO:"${this.firmwareVersion}"`);
                },
            },
            {
                name: 'powerQuery',
                regExp: /DISPLAY\.POWER\?/i,
                callback: (match) => {
                    this.socket.send(`DISPLAY.POWER:${this.power ? 'ON' : 'OFF'}`);
                },
            },
            {
                name: 'powerSet',
                regExp: /DISPLAY\.POWER=(ON|OFF)/i,
                callback: (match) => {
                    this.power = match[1] === 'ON';
                    this.socket.send(`DISPLAY.POWER:${this.power ? 'ON' : 'OFF'}`);
                },
            },
            {
                name: 'videoQuery',
                regExp: /SOURCE.SELECT\?/i,
                callback: (match) => {
                    this.socket.send(`SOURCE.SELECT:${this.videoSelection}`);
                },
            },
            {
                name: 'videoSet',
                regExp: /SOURCE.SELECT=(.+)/i,
                callback: (match) => {
                    this.videoSelection = match[1];
                    this.socket.send(`SOURCE.SELECT:${this.videoSelection}`);
                },
            },
            {
                name: 'volumeMuteQuery',
                regExp: /AUDIO.MUTE\?/i,
                callback: (match) => {
                    this.socket.send(`AUDIO.MUTE:${this.volumeMute ? 'ON' : 'OFF'}`);
                },
            },
            {
                name: 'volumeMuteSet',
                regExp: /AUDIO.MUTE=(ON|OFF)/i,
                callback: (match) => {
                    this.volumeMute = match[1].toUpperCase() === 'ON';
                    this.socket.send(`AUDIO.MUTE:${this.volumeMute ? 'ON' : 'OFF'}`);
                },
            },
            {
                name: 'volumeQuery',
                regExp: /AUDIO\.VOLUME\?/i,
                callback: (match) => {
                    this.socket.send(`AUDIO.VOLUME:${this.volume}`);
                },
            },
            {
                name: 'volumeSet',
                regExp: /AUDIO\.VOLUME=(\d+)/i,
                callback: (match) => {
                    this.volume = match[1];
                    this.socket.send(`AUDIO.VOLUME:${this.volume}`);
                },
            },
            {
                name: 'invalid',
                regExp: /(.+)=.+/i,
                callback: (match) => {
                    this.socket.send(`${match[1]}!ERR 4}`);
                },
            },
        ];
        this.socket.onBeforeConnect(this.onBeforeConnect.bind(this));
    }
    wakeOnLan() {
        this.power = true;
        this.socket.setCanConnect(this.socket.getPort() !== 5000 || this.power);
    }
    onBeforeConnect(host, port, username, password) {
        return __awaiter(this, void 0, void 0, function* () {
            this.socket.setCanConnect(port !== 5000 || this.power);
        });
    }
    onConfigure(config) {
        var _a;
        let lowestCode;
        for (const videoInput of Object.values((_a = config.videoInputs) !== null && _a !== void 0 ? _a : {})) {
            const code = videoInput.code;
            if (this.videoSelection === code)
                return;
            if (lowestCode === undefined || parseInt(code, 10) < parseInt(lowestCode, 10)) {
                lowestCode = code;
            }
        }
        this.videoSelection = lowestCode !== null && lowestCode !== void 0 ? lowestCode : 'HDMI.1';
    }
}
PlanarMSeries.emulatorType = 'socketEmulator';
PlanarMSeries.key = '-NE_kW3XwumLnteiQ81v';
